import { CSSProperties, ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import { styled } from 'styled-components';

import { Drawer } from '@sorare/core/src/atoms/layout/Drawer';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { CloseButton } from '@sorare/core/src/components/dialog/CloseButton';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';
import { glossary } from '@sorare/core/src/lib/glossary';

const StyledDrawer = styled(Drawer)`
  background: var(--c-black);
  padding: var(--double-unit);
`;

const DrawerContent = styled(Vertical)`
  padding: var(--double-unit) 0;
`;
const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr 50px;
  align-items: center;
`;

type Props = Pick<ComponentProps<typeof Drawer>, 'children' | 'open'> & {
  onClose: () => void;
};

export const FiltersDrawer = ({ children, onClose, ...rest }: Props) => {
  const isTabletAndAbove = useIsTabletAndAbove();
  return (
    <StyledDrawer
      onClose={onClose}
      fullScreen={!isTabletAndAbove}
      onBackdropClick={onClose}
      {...rest}
    >
      <Header>
        <LabelM className="text-center" bold>
          <FormattedMessage {...glossary.filterBy} />
        </LabelM>
        <CloseButton onClose={onClose} />
      </Header>
      <DrawerContent
        style={{ '--label-padding': 'var(--half-unit) 0' } as CSSProperties}
      >
        {children}
      </DrawerContent>
    </StyledDrawer>
  );
};
